import axios from 'axios'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*' }
})

const API = {
  filtersTheme: '/themes',
  filtersInvestigations: '/investigations',
  all: '/items',
  items: '/items/:id',
  batches: '/batches/:ids',
  linkedBatches: '/batches/:ids/linked',
  search: '/search',
  random: 'items/random'
}

function url (path, ...segments) {
  let i = 0
  const uri = path.replace(/:\w+/g, () => {
    const s = segments[i]
    i += 1
    return s
  })

  return uri
}

function check (fn = Function) {
  return new Promise((resolve) => {
    fn.then((response) => {
      // console.log("fetch success");
      resolve(response)
    }).catch((error) => {
      console.log('error config: ', error.config)

      if (error.response) {
        console.log('error data: ', error.response.data)
        console.log('error status: ', error.response.status)
        console.log('error headers: ', error.response.headers)
        resolve({
          error: {
            data: error.response.data,
            status: error.response.status,
            headers: error.response.headers
          }
        })
      } else if (error.request) {
        console.log('error request: ', error.request)
        resolve({ error: { request: error.request } })
      } else {
        console.log('Error', error.message)
        resolve({ error: { message: error.message } })
      }
    })
  })
}

export default {
  install (Vue) {
    const $api = {
      getAll () {
        return check(http.get(url(API.all)))
      },
      getFilters (type) {
        if (type === 'theme') {
          return check(http.get(url(API.filtersTheme)))
        } else if (type === 'investigations') {
          return check(http.get(url(API.filtersInvestigations)))
        }
      },
      getBatches (ids) {
        return check(http.get(url(API.batches, ids)))
      },
      getLinkedBatches (ids) {
        return check(http.get(url(API.linkedBatches, ids)))
      },
      search (data) {
        return check(http.post(url(API.search), data))
      },
      getItem (id) {
        return check(http.get(url(API.items, id)))
      },
      getRandom () {
        return check(http.get(url(API.random)))
      }

    }

    Vue.prototype.$api = $api
    Vue.$api = $api
  }
}
